import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import FleetManagement from './pages/FleetManagement';
import PatientManagement from './pages/PatientManagement';
import StaffManagement from './pages/StaffManagement';
import EmergencyContacts from './pages/EmergencyContacts';
import LiveTracking from './pages/LiveTracking';
import './App.css';

function App() {
  return (
    <Router>
      <div className="flex h-screen bg-gray-50">
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/fleet" element={<FleetManagement />} />
              <Route path="/patients" element={<PatientManagement />} />
              <Route path="/staff" element={<StaffManagement />} />
              <Route path="/emergency-contacts" element={<EmergencyContacts />} />
              <Route path="/tracking" element={<LiveTracking />} />
            </Routes>
          </main>
        </div>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App; 